import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Avatar from "../Sidebar/components/Avatar";

export default function MerchantDropdownItem({
  name,
  subtitle,
  imageUrl,
  fit = "contain",
  selected = false,
  onClick,
}) {
  return (
    <button
      type="button"
      className={`navbar-merchant-item ${selected ? "is-selected" : ""}`}
      onClick={onClick}
    >
      <Avatar
        src={imageUrl}
        alt={name}
        className="navbar-merchant-item__avatar"
        fit={fit}
      />
      <span className="navbar-merchant-item__content">
        <strong>{name}</strong>
        <small>{subtitle}</small>
      </span>
      <span className="navbar-merchant-item__check" aria-hidden="true">
        {selected ? <FontAwesomeIcon icon={faCheck} /> : null}
      </span>
    </button>
  );
}
